import {
  serializeArray, serializeDateTime,
  serializeIdentical,
  serializeNumber,
  serializeObject,
  serializeObjectKeysToSnakeCase, serializeOptional,
  serializeText
} from './serializer';
import {
  Transaction,
  TransactionHistoryItem,
  SPaymentAttributes,
  OPIPaymentAttributes,
  ZVTPaymentAttributes, PaginatedTransactions
} from '../models';

const serializeSPaymentAttributes = serializeObject<SPaymentAttributes | OPIPaymentAttributes | ZVTPaymentAttributes>({
  spos_payment_transaction_id: serializeOptional(serializeText),
  spos_payment_transaction_data: serializeOptional(serializeText),
  spos_payment_customer_receipt: serializeOptional(serializeText),
  spos_payment_merchant_receipt: serializeOptional(serializeText),
  spos_payment_card_circuit: serializeOptional(serializeText),
  spos_refund_transaction_id: serializeOptional(serializeText),
  spos_refund_transaction_data: serializeOptional(serializeText),
  spos_refund_customer_receipt: serializeOptional(serializeText),
  spos_refund_merchant_receipt: serializeOptional(serializeText),
  spos_refund_card_circuit: serializeOptional(serializeText),
  spos_reversal_transaction_id: serializeOptional(serializeText),
  spos_reversal_transaction_data: serializeOptional(serializeText),
  spos_reversal_customer_receipt: serializeOptional(serializeText),
  spos_reversal_merchant_receipt: serializeOptional(serializeText),
  spos_reversal_card_circuit: serializeOptional(serializeText),
  opi_payment_transaction_id: serializeOptional(serializeText),
  zvt_payment_transaction_id: serializeOptional(serializeText),
  zvt_refund_transaction_id: serializeOptional(serializeText),
  zvt_reversal_transaction_id: serializeOptional(serializeText),
  zvt_end_of_day_transaction_id: serializeOptional(serializeText)
});

const serializeTransactionItem = serializeObjectKeysToSnakeCase(serializeObject<TransactionHistoryItem>({
  id: serializeNumber,
  amount: serializeNumber,
  taxRate: serializeNumber,
  taxAmount: serializeNumber,
  discountType: serializeIdentical,
  discountAmount: serializeNumber,
  discountTaxAmount: serializeNumber,
  code: serializeText,
  title: serializeText,
  quantity: serializeNumber,
  productId: serializeNumber,
  returnedQuantity: serializeOptional(serializeNumber),
}));

export const serializeTransaction = serializeObjectKeysToSnakeCase(serializeObject<Transaction>({
  id: serializeNumber,
  transactionNumber: serializeNumber,
  total: serializeNumber,
  taxTotal: serializeNumber,
  userName: serializeText,
  zOutStatus: serializeText,
  editUrl: serializeText,
  createdAt: serializeDateTime,
  items: serializeArray(serializeTransactionItem),
  paymentMethod: serializeOptional(serializeText),
  cartAttributes: serializeSPaymentAttributes,
  receiptUrl: serializeOptional(serializeText),
  receiptImageUrl: serializeOptional(serializeText),
  receiptEposUrl: serializeOptional(serializeText)
}));

export const serializeTransactions = serializeArray<Transaction>(serializeTransaction);

export const serializePaginatedTransactions = serializeObject<PaginatedTransactions>({
  meta: serializeObject({
    page: serializeNumber,
    total: serializeNumber
  }),
  transactions: serializeTransactions
});
